import React from 'react';
import ListItemSelect from '../ListItemSelect';
import Text, { TextProps } from '../Text';
import Box from '../Box';
import { Location } from '@wix/wix-ui-icons-common';
import { st, classes } from './AddressInputItem.st.css';
import {
  AddressInputItemProps,
  AddressInputItemBuilderProps,
} from './AddressInputItem.types';
import { DropdownLayoutValueOption } from '../DropdownLayout';
import { IconThemeContext } from '../WixDesignSystemIconThemeProvider/IconThemeContext';

/** This component is used to display an address item mainly in <AddressInput/> component. */
class AddressInputItem extends React.PureComponent<AddressInputItemProps> {
  static displayName = 'AddressInputItem';

  static defaultProps = {
    optionLayout: 'single-line',
  };
  render() {
    const {
      dataHook,
      className,
      secondaryLabel,
      optionLayout,
      mainLabel,
      suffix,
      prefix,
      disabled,
      selected,
      highlighted,
      onClick,
    } = this.props;

    const textProps: TextProps = {
      tagName: 'div',
      ellipsis: true,
      skin: disabled ? 'disabled' : 'standard',
      light: selected,
    };

    return (
      <IconThemeContext.Consumer>
        {({ icons = {} }) => {
          const LocationIcon = icons.AddressInputItem?.Location || Location;
          const defaultPrefix =
            prefix !== undefined ? prefix : <LocationIcon />;

          return (
            <ListItemSelect
              dataHook={dataHook}
              className={st(classes.root, { optionLayout }, className)}
              subtitle={secondaryLabel}
              title={<Text {...textProps}>{mainLabel}</Text>}
              suffix={<Box>{suffix}</Box>}
              prefix={<Box>{defaultPrefix}</Box>}
              ellipsis
              disabled={disabled}
              selected={selected}
              highlighted={highlighted}
              onClick={onClick}
            />
          );
        }}
      </IconThemeContext.Consumer>
    );
  }
}

export const addressInputItemBuilder = ({
  id,
  className,
  prefix,
  mainLabel,
  secondaryLabel,
  suffix,
  disabled,
  dataHook,
  optionLayout,
  onClick,
  displayLabel,
}: AddressInputItemBuilderProps): DropdownLayoutValueOption => ({
  id,
  disabled,
  overrideOptionStyle: true,
  label: displayLabel,
  value: ({ selected, hovered, ...rest }) => (
    <AddressInputItem
      optionLayout={optionLayout}
      dataHook={dataHook}
      className={className}
      prefix={prefix}
      mainLabel={mainLabel}
      secondaryLabel={secondaryLabel}
      suffix={suffix}
      selected={selected}
      highlighted={hovered}
      onClick={onClick}
      {...rest}
    />
  ),
});

export default AddressInputItem;
